import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { ViewIcon } from '@chakra-ui/icons';
import { SectionTag } from '../SectionTag';

function CardTextArea({ data, showSectionTag, hideExcerpt, visited }) {
  const { title, section, excerpt } = data;

  const VisitedBox = () => (
    <Flex
      color='gray.700'
      textTransform='uppercase'
      fontSize='11px'
      fontWeight='600'
      alignItems='center'
      gap='5px'
      background='zinc.100'
      padding='5px 8px'
      mt={5}
    >
      <ViewIcon /> Viewed
    </Flex>
  );

  return (
    <Flex direction='column' alignItems='start' width='100%'>
      <Flex direction='column' alignItems='start' justifyContent='center' gap='5px' width='100%'>
        {showSectionTag && section && <SectionTag title={section} />}
        <Text width='100%' fontSize='xl' fontWeight='700' color='inherit' lineHeight='1'>
          {title}
        </Text>
        {!hideExcerpt && excerpt && (
          <Text
            width='100%'
            fontSize={{ base: 'sm', lg: 'md' }}
            fontWeight='normal'
            color='black'
            lineHeight='base'
            sx={{
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 3,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {excerpt}
          </Text>
        )}
        {visited && <VisitedBox />}
      </Flex>
    </Flex>
  );
}

export default CardTextArea;
